import * as React from 'react';
/**
 * Unit system types
 */
export type Unit = 'imperial' | 'metric';

interface PreferencesContextProps {
  unit: Unit;
}

export const PreferencesContext = React.createContext<PreferencesContextProps>({
  unit: 'imperial',
});

interface PreferencesProviderProps extends PreferencesContextProps {
  children: React.ReactNode;
}

export function PreferencesProvider({
  children,
  unit,
}: PreferencesProviderProps) {
  return (
    <PreferencesContext.Provider value={{ unit }}>
      {children}
    </PreferencesContext.Provider>
  );
}

export function usePreferences() {
  const context = React.useContext(PreferencesContext);
  if (context === undefined) {
    throw new Error('usePreferences must be used within a PreferencesProvider');
  }
  return context;
}
export default PreferencesProvider;
